import * as React from "react";

import { useAppearance } from "@/domain/user/components/appearance-context";
import { useRightAsideTransition } from "@/hooks/use-right-aside-transition";
import { cn } from "@/lib/cn";

interface RightAsideContentWrapperProps {
  children: React.ReactNode;
  className?: string;
  transitionDuration?: number;
  transitionKey?: string | number;
}

export const RightAsideContentWrapper: React.FC<RightAsideContentWrapperProps> = ({
  children,
  className,
  transitionDuration = 300,
  transitionKey,
}) => {
  const { animationsEnabled } = useAppearance();
  const { isVisible, isTransitioning, shouldRender } = useRightAsideTransition({
    key: transitionKey || "default",
    transitionDuration,
  });

  return (
    <div
      className={cn(
        animationsEnabled && "transition-all duration-300 ease-in-out",
        isVisible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0",
        isTransitioning && "pointer-events-none",
        className,
      )}
      style={{
        transitionDuration: animationsEnabled ? `${transitionDuration}ms` : "0ms",
      }}
    >
      {shouldRender && children}
    </div>
  );
};
